// extracted by mini-css-extract-plugin
export var bar = "Navbar-module--bar--d31c6";
export var barOpen = "Navbar-module--barOpen--fcba1";
export var hamburger = "Navbar-module--hamburger--c3d7e";
export var insta = "Navbar-module--insta--e5bc6";
export var instaImg = "Navbar-module--instaImg--a2886";
export var logoContainer = "Navbar-module--logoContainer--5c91a";
export var logoImg = "Navbar-module--logoImg--50620";
export var menuOpen = "Navbar-module--menuOpen--8adbb";
export var name = "Navbar-module--name--e6c38";
export var navItems = "Navbar-module--navItems--c43df";
export var navbar = "Navbar-module--navbar--7f6e3";
export var noScroll = "Navbar-module--noScroll--45a0d";
export var schoolName = "Navbar-module--schoolName--de0d5";